// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.field-clearfix  {\n     height: 0px;\n     margin-bottom: 0px !important;\n}\n", ""]);
// Exports
module.exports = exports;
